<app-form-view [popup]="formPopup" [contentLoader]="loader">
	<form-title>
		{{title}}
	</form-title>
	<content-area>
		<div class="conversation-form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
			<div fxLayout="row" fxLayoutAlign="center start">
				<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
					<div class="form-info">
						<p class="body-text">
							{{info}}
						</p>
					</div>
					<div fxLayout="row" fxLayoutAlign="center center">
						<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
							fxLayoutGap.xs="10px">
							<div fxLayout fxLayoutAlign="center start" class="form-container">
								<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
									fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap="10px"
									fxLayoutGap.xs="10px" (formObject)="formObjectReader($event)"></app-form-group>
							</div>
							<div fxLayout="column" fxLayoutAlign="start stretch">
								<app-alert id="conversationAlert"></app-alert>
								<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
									<ng-container *ngIf="action === 'rejectConversation'">
										<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
											type="button">{{locale.translate('reject')}}</button>
									</ng-container>
									<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
										type="button">{{locale.translate('cancel')}}</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</content-area>
</app-form-view>
